import React, { useMemo, useState, useRef, Component } from 'react';
interface FloatingCodeProps {
  className?: string;
}
const codeLines = ['const [data, setData] = useState<Project[]>([])', 'const response = await fetch("/api/projects")', 'export function useAnalytics(trackingId: string) {', '  return useMemo(() => createClient(config), [config])', '}', '', 'interface ServiceConfig {', '  endpoint: string', '  timeout: number', '  retries?: number', '}', '', 'const optimized = pipeline(transform, validate, cache)', 'await deploy({ env: "production", region: "eu-west" })', '', 'export const metadata: Metadata = {', '  title: "fooble media",', '  description: "Digital Solutions"', '}', '', 'function Component({ children }: Props) {', '  const ref = useRef<HTMLDivElement>(null)', '  const isInView = useInView(ref, { once: true })', '  return <motion.div ref={ref}>{children}</motion.div>', '}', '', 'const result = await prisma.project.findMany({', '  where: { status: "published" },', '  orderBy: { createdAt: "desc" }', '})', '', 'export async function generateStaticParams() {', '  const projects = await getProjects()', '  return projects.map((p) => ({ slug: p.slug }))', '}'];
export function FloatingCode({
  className = ''
}: FloatingCodeProps) {
  const allLines = [...codeLines, ...codeLines];
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-88">
      <div className="font-mono text-[11px] leading-relaxed text-white/[0.04] whitespace-pre animate-scroll-code" style={{
      animation: 'scrollCode 60s linear infinite'
    }} data-id="element-89">
        {allLines.map((line, index) => <div key={index} className="px-4" data-id="element-90">
            {line || '\u00A0'}
          </div>)}
      </div>
      <style data-id="element-91">{`
        @keyframes scrollCode {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
      `}</style>
    </div>;
}